export const INFO = {
  address: "C. Periodista Pirula Arderius, 12",
  city: "03001 Alicante",
  // Numéro WhatsApp au format international, sans + ni espaces (ex : "34600112233").
  // ⚠️ PLACEHOLDER — remplacer par le vrai numéro, sinon le bouton de réservation
  // ouvre une conversation avec un numéro qui n'existe pas.
  whatsapp: "34600000000",
  instagram: "https://www.instagram.com/deseos.brunch.coffee/",
  facebook: "#",
  tiktok: "#",
  directions: "https://www.google.com/maps/search/?api=1&query=C.+Periodista+Pirula+Arderius,+12,+03001+Alicante",
  mapEmbed:
    "https://www.google.com/maps?q=C.+Periodista+Pirula+Arderius,+12,+03001+Alicante&hl=es&z=17&output=embed",
};
